import { CascoPackage } from '@insurance/api/requests'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { InsuranceCommonAmount } from './InsuranceCommonAmount'
import { InsuranceMiniAmount } from './InsuranceMiniAmount'
import { formProps } from './utils'

type Props = {
  hiddenCost?: boolean
}

export const InsuranceAmount = ({ hiddenCost }: Props) => {
  const { t } = useTranslation()
  const { insurancePackageProps } = formProps(t)

  const insurancePackage = Form.useWatch(insurancePackageProps.name, {
    preserve: true
  })

  const isMini = insurancePackage === CascoPackage.MINI

  return !isMini ? (
    <InsuranceCommonAmount hiddenCost={hiddenCost} />
  ) : (
    <InsuranceMiniAmount />
  )
}
